<template>
  <div class="v-autocomplete">
    <!-- This is basically the same as the upstream v-autocomplete template, with some small
         but crucial tweaks to make it work with vue 3. -->
    <div class="v-autocomplete-input-group" :class="{'v-autocomplete-selected': value}">
      <input v-bind="inputAttrs" ref="input" v-model="searchText" type="search"
             :class="inputAttrs.class || inputClass"
             :placeholder="inputAttrs.placeholder || placeholder"
             :disabled="inputAttrs.disabled || disabled"
             @blur="blur" @focus="focused" @input="inputChange"
             @keyup.enter="keyEnter" @keydown.tab="keyEnter"
             @keydown.up="keyUp" @keydown.down="keyDown">
    </div>
    <div v-if="show" class="v-autocomplete-list">
      <div v-for="(item, i) in internalItems" :key="i" class="v-autocomplete-list-item"
           :class="{'v-autocomplete-item-active': i === cursor}" @click="onClickItem(item)" @mouseover="cursor = i">
        <component :is="componentItem" :item="item" :search-text="searchText" />
      </div>
    </div>
    <slot name="after-list" />
  </div>
</template>

<script>
import VAutocomplete from 'v-autocomplete'

export default {
  extends: VAutocomplete,

  emits: ['blur', 'change', 'focus', 'input', 'item-clicked', 'item-selected', 'update-items'],

  methods: {
    clearSearchText() {
      this.searchText = ''
    },

    focus() {
      this.$refs.input.focus()
    },

    // This method exists in the upstream version as focus(), but we want to use that name for something else
    focused() {
      this.$emit('focus', this.searchText)
      this.showList = true
    }
  }
}
</script>
